import { GetServerSideProps } from 'next';
import React from 'react';

import { DefaultPage, RenderBlocks } from '@klappir/container/graphcms';
import { getPage } from '@klappir/data/graphcms';
import { DataGraphcms } from '@klappir/types';
import { SEO } from '@klappir/ui/core';

const SustainabilityPlatformPage = ({
  content,
}: DataGraphcms.ArticlesPageProps) => {
  if (!content) {
    return <div>Error 404?</div>;
  }
  return (
    <DefaultPage localizations={content.localizations}>
      {content?.seo && (
        <SEO
          canonical="https://www.klappir.com/sustainability-platform"
          {...content.seo}
        />
      )}

      <RenderBlocks blocks={content?.blocks ?? []} />
    </DefaultPage>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const content = await getPage('sustainability-platform', context.locale);

  return {
    props: { content },
  };
};

export default SustainabilityPlatformPage;
